import React from "react";

const DefaultIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor"
       strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
    <polyline points="3.27 6.96 12 12.01 20.73 6.96" />
    <line x1="12" y1="22.08" x2="12" y2="12" />
  </svg>
);

const EmptyState = ({
  icon = <DefaultIcon />,
  title = "Nothing here yet",
  description,
  action,
  className = "",
}) => (
  <div className={`state ${className}`}>
    <div className="state__icon" aria-hidden="true">{icon}</div>
    <h4 className="state__title">{title}</h4>
    {description && <p className="state__desc">{description}</p>}
    {action && <div className="state__cta">{action}</div>}
  </div>
);

export default EmptyState;
